import { useOnline, useOutboxCounts } from '../offline/index.js';
import { syncState } from '../offline/syncState.js';

// Text pill: are we online, and is anything still waiting to send.
export default function SyncStatus() {
  const online = useOnline();
  const { label, tone } = syncState({ online, ...useOutboxCounts() });
  return <span className={`sync sync-${tone === 'busy' ? 'warn' : tone}`} role="status">{label}</span>;
}
